import { apiFetch } from '@/lib/api/client';
import type {
  CreateLearningSpaceInput,
  LearningSpaceView,
  UpdateLearningSpaceInput,
} from '@/features/learning-spaces/types';
import type { PagedData } from '@/lib/api/types';

/** `GET /learning-spaces`. Tenant-scoped (ADR-026 Addendum, AO-2). */
export async function listLearningSpaces(
  page = 1,
  limit = 20,
): Promise<PagedData<LearningSpaceView>> {
  return apiFetch<PagedData<LearningSpaceView>>(
    `/learning-spaces?page=${String(page)}&limit=${String(limit)}`,
    { tenantScoped: true },
  );
}

/** `GET /learning-spaces/:id`. Tenant-scoped. */
export async function getLearningSpace(id: string): Promise<LearningSpaceView> {
  return apiFetch<LearningSpaceView>(`/learning-spaces/${id}`, { tenantScoped: true });
}

/** `POST /learning-spaces`. Tenant-scoped; requires `learning_spaces:manage`. */
export async function createLearningSpace(
  input: CreateLearningSpaceInput,
): Promise<LearningSpaceView> {
  return apiFetch<LearningSpaceView>('/learning-spaces', {
    method: 'POST',
    body: input,
    tenantScoped: true,
  });
}

/** `PATCH /learning-spaces/:id`. Tenant-scoped; requires `learning_spaces:manage`. */
export async function updateLearningSpace(
  id: string,
  input: UpdateLearningSpaceInput,
): Promise<LearningSpaceView> {
  return apiFetch<LearningSpaceView>(`/learning-spaces/${id}`, {
    method: 'PATCH',
    body: input,
    tenantScoped: true,
  });
}

/**
 * `DELETE /learning-spaces/:id`. Tenant-scoped; requires
 * `learning_spaces:manage`. Soft deactivation (`deactivateLearningSpace`'s
 * doc comment) - there is no reactivation endpoint.
 */
export async function deactivateLearningSpace(id: string): Promise<void> {
  await apiFetch<unknown>(`/learning-spaces/${id}`, { method: 'DELETE', tenantScoped: true });
}
